

function Links() {
  return <div className="main-wrapper">
    
      

      <h2>Weiterführende Links</h2>

      <h3>
        Contact Improvisation
      </h3>

      <a href="https://contactjam-muenchen.de" target="_blank" rel="noopener noreferrer">
        contactjam-muenchen.de
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" ver>
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 14v4.833A1.166 1.166 0 0 1 16.833 20H5.167A1.167 1.167 0 0 1 4 18.833V7.167A1.166 1.166 0 0 1 5.167 6h4.618m4.447-2H20v5.768m-7.889 2.121 7.778-7.778"/>
        </svg>
      </a>

      <h3>
        ContacTango
      </h3>

      <a href="https://contangomuenchen.de" target="_blank" rel="noopener noreferrer">
        contangomuenchen.de
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" ver>
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 14v4.833A1.166 1.166 0 0 1 16.833 20H5.167A1.167 1.167 0 0 1 4 18.833V7.167A1.166 1.166 0 0 1 5.167 6h4.618m4.447-2H20v5.768m-7.889 2.121 7.778-7.778"/>
        </svg>
      </a>

      <h3>
        Feldenkrais
      </h3>

      <a href="https://innere-bewegung.de" target="_blank" rel="noopener noreferrer">
        innere-bewegung.de
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" ver>
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 14v4.833A1.166 1.166 0 0 1 16.833 20H5.167A1.167 1.167 0 0 1 4 18.833V7.167A1.166 1.166 0 0 1 5.167 6h4.618m4.447-2H20v5.768m-7.889 2.121 7.778-7.778"/>
        </svg>
      </a>

      <h3>
        Holistische Tanz- und Bewegungstherapie
      </h3>

      <a href=" https://holistische-tanztherapie.de" target="_blank" rel="noopener noreferrer">
        holistische-tanztherapie.de
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" ver>
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 14v4.833A1.166 1.166 0 0 1 16.833 20H5.167A1.167 1.167 0 0 1 4 18.833V7.167A1.166 1.166 0 0 1 5.167 6h4.618m4.447-2H20v5.768m-7.889 2.121 7.778-7.778"/>
        </svg>
      </a>

      <h3>
        Seminarhaus
      </h3>

      <a href="https://zentrum-lilie.de" target="_blank" rel="noopener noreferrer">
        zentrum-lilie.de
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" ver>
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 14v4.833A1.166 1.166 0 0 1 16.833 20H5.167A1.167 1.167 0 0 1 4 18.833V7.167A1.166 1.166 0 0 1 5.167 6h4.618m4.447-2H20v5.768m-7.889 2.121 7.778-7.778"/>
        </svg>
      </a>

      <h3>
        Tango Argentino
      </h3>

      <a href="https://tango-x.de" target="_blank" rel="noopener noreferrer">
        tango-x.de
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" ver>
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 14v4.833A1.166 1.166 0 0 1 16.833 20H5.167A1.167 1.167 0 0 1 4 18.833V7.167A1.166 1.166 0 0 1 5.167 6h4.618m4.447-2H20v5.768m-7.889 2.121 7.778-7.778"/>
        </svg>
      </a>

      <h3>
        zibko, Zentrum „In BeWEGung kommen"
      </h3>

      <a href="https://zibko.de" target="_blank" rel="noopener noreferrer">
        zibko.de
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" ver>
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 14v4.833A1.166 1.166 0 0 1 16.833 20H5.167A1.167 1.167 0 0 1 4 18.833V7.167A1.166 1.166 0 0 1 5.167 6h4.618m4.447-2H20v5.768m-7.889 2.121 7.778-7.778"/>
        </svg>
      </a>

    </div>
}
export default Links;